var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.clickAdd)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                          _vm._v(
                            _vm._s(_vm.i18n("Organization.DoubleAs")) + " "
                          ),
                        ]),
                        _c("ValidationProvider", {
                          attrs: {
                            tag: "section",
                            name: _vm.i18n("Organization.DoubleAs"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("treeselect", {
                                      attrs: {
                                        options: _vm.departmentOptions,
                                        searchable: true,
                                        "show-count": true,
                                        "default-expand-level": 1,
                                        placeholder: "請選擇",
                                        "value-format": "object",
                                      },
                                      model: {
                                        value: _vm.department,
                                        callback: function ($$v) {
                                          _vm.department = $$v
                                        },
                                        expression: "department",
                                      },
                                    }),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "form-group w-100" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                        _vm._v(_vm._s(_vm.i18n("Basic.Supervisor"))),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.IsSupervisor,
                              expression: "IsSupervisor",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.IsSupervisor = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: true } }, [
                            _vm._v("是"),
                          ]),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("否"),
                          ]),
                        ]
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary btn-sm",
                        staticStyle: {
                          "margin-left": "6px",
                          "margin-right": "10px",
                        },
                        attrs: { type: "button" },
                        on: { click: _vm.clickCancel },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-sm",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }